const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function Sparkbars({ data, width = 130, height = 34, direction = "past", highlightIndex }) {
  const max = Math.max(1, ...data);
  const barWidth = 10;
  const gap = 4;
  const barsWidth = data.length * barWidth + (data.length - 1) * gap;
  const offsetX = (width - barsWidth) / 2;
  const total = data.reduce((sum, value) => sum + value, 0);
  const today = new Date().getDay();
  const emphasisIndex = highlightIndex ?? (direction === "future" ? 0 : data.length - 1);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={`Daily counts, ${total} total`}
      style={{ display: "block", overflow: "visible" }}
    >
      {data.map((value, index) => {
        const barHeight = Math.max(2, (value / max) * (height - 4));
        const x = offsetX + index * (barWidth + gap);
        const y = height - barHeight;
        const isEmphasized = index === emphasisIndex;
        const offset = direction === "future" ? index : -(data.length - 1 - index);
        const dayIndex = (((today + offset) % 7) + 7) % 7;

        return (
          <rect
            key={index}
            x={x}
            y={y}
            width={barWidth}
            height={barHeight}
            rx={2}
            fill="var(--ops-accent-ink)"
            opacity={isEmphasized ? 1 : 0.32}
          >
            <title>{`${DAY_LABELS[dayIndex]}: ${value}`}</title>
          </rect>
        );
      })}
    </svg>
  );
}
